var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-pr",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M51.6 0h708.7v708.7H51.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-37.3) scale(.72249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed0000",
    d: "M0 0h1063v708.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 141.7h1063v141.8H0zm0 283.5h1063v141.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0050f0",
    d: "m0 0 610 353.9L0 707.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m268.2 450.5-65.7-49-65.3 49.5 24.3-80.5-65.3-49.7 80.7-.7 25-80.2 25.6 80 80.7.1-64.9 50.2 24.9 80.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.56516b5763593029ab277a07ef5d843d.svg";
export { ForwardRef as ReactComponent };